import React from 'react';

class SMHomeStaffFeaturesView extends React.Component {
  render() {
    return (
      <div className="container top-container">
        <div className="top-title__container clearfix">
          <h2 className="top-title">スタッフのおすすめ</h2>
          <a href={Routes.features_path()} className="pc-hide__sm-show top-more__area-link">もっと見る</a>
        </div>
        <div className="top-units__container">
          <div className="row">
            {this.props.staffFeatures.map((staffFeature, index) => {
              const feature = staffFeature.item;
              return (
                <div key={index} className="col-xs-3 md-matome-list">
                  <a key={staffFeature.id} href={Routes.feature_path(feature.uid)}>
                    <div className="md-top-units mdl-shadow--2dp">
                      <div className="md-matome-image">
                        <img src={feature.image.replace('large_slide', 'square')} alt={feature.title}
                             className="md-matome-image__pict" />
                      </div>
                      <h3 className="md-matome-subtitle">{feature.title}</h3>
                    </div>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
        <div className="sm-hide top-more__area">
          <a href={Routes.features_path()} className="top-more__area-link">スタッフのおすすめをもっと見る</a>
        </div>
      </div>
    );
  }
}
export default SMHomeStaffFeaturesView;


// WEBPACK FOOTER //
// ./app/javascript/components/home/SMHomeStaffFeaturesView.jsx